module.exports = __webpack_public_path__ + "static/media/logo2.d52c0130.png";